import adjustmentListPage from '@/pages/adjustment-sheet/adjustment-list';
import addAdjustsheetPage from '@/pages/adjustment-sheet/add-adjustsheet';
import adjustmentDetailPage from '@/pages/adjustment-sheet/adjustment-order-detail';



// 调整单列表
export const adjustmentList = {
  path: 'Order/adjustment/adjustmentList',
  component: adjustmentListPage
}

//新增调整单
export const addAdjustsheet = {
  path: 'Order/adjustment/addAdjustsheet',
  component: addAdjustsheetPage
}

//调整单详情
export const adjustmentDetail = {
  path: 'Order/adjustment/adjustmentDetail',
  component: adjustmentDetailPage
}


// WEBPACK FOOTER //
// ./src/router/adjustment-sheet.js